<template>
  <section :class="$style.dexWrapper">
    <div :class="$style.title">{{ $t("Deliver to") }}</div>
    <div :class="$style.dexItem">
      <div :class="$style.walletAddressContainer">
        <div :title="walletAddress" :class="$style.walletAddress">
          {{ walletAddress }}
        </div>
        <div v-if="showCopyButton" :class="$style.copyAction">
          <CopyButtonV2 placement="top" :copyText="walletAddress" />
        </div>
      </div>

      <div v-if="network" :class="$style.network">
        {{ $t("Network") }}: {{ network }}
      </div>
    </div>
  </section>
</template>

<script>
import CopyButtonV2 from "@/components/CopyButtonV2.vue";

export default {
  name: "DexPanel",
  props: {
    walletAddress: [String],
    network: [String],
    showCopyButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  components: {
    CopyButtonV2
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style module lang="scss">
@import "~rfs/scss";
.dexWrapper {
  // @include rfs(22.5rem, max-width);

  .title {
    @include rfs(16px);
    @include rfs(20px, margin-bottom);

    text-align: left;
    font-weight: 500;
    color: var(--primary);
  }
  .dexItem {
    @include rfs(14px);

    display: flex;
    align-items: center;
    justify-content: space-between;

    .walletAddressContainer {
      display: flex;
      align-items: center;

      .walletAddress {
        flex: 1;
        text-align: left;
        color: var(--legend-c-text);
      }
      .copyAction {
        position: relative;
        margin-left: 4px;

        // :global(.copyTips) {
        //   right: -16.25rem;
        //   top: rfs-value(-10px);
        // }
      }
    }

    .network {
      flex: 1;
      text-align: right;

      color: var(--grey-cool-light);
    }
  }

  // .dexItem {
  //   text-align: left;
  //   .title {
  //     @include rfs(0.875rem);
  //     @include rfs(0.4375rem, margin-bottom);

  //     font-weight: 600;
  //     color: var(--legend-c-text);
  //   }
  //   .itemValue {
  //     @include rfs(0.875rem);
  //     @include rfs(0.4375rem, margin-bottom);

  //     color: var(--legend-c-text);
  //   }
  // }
}
</style>
